import axiosObject from './axiosObject';

const controller = new AbortController();

const api = {
    post: async (url, data, abortController) =>  {
        if (abortController) {
            return await axiosObject.post(url, data, { signal: controller.signal });
        } else {
            return await axiosObject.post(url, data);
        }
    },
    get: async (url, abortController) => {
        if (abortController) {
            return await axiosObject.get(url, { signal: controller.signal });
        } else {
            return await axiosObject.get(url);
        }
    },
    delete: async (url, abortController) => {
        if (abortController) {
            return await axiosObject.delete(url, { signal: controller.signal });
        } else {
            return await axiosObject.delete(url);
        }
    }
}

export default api;